<template>
    <div style="width: 100%;height: 100%; position: absolute;">
        <top-navbar></top-navbar>
        <div id="map"></div>
    </div>
</template>

<script>
    import TopNavbar from "./Layout/TopNavbar.vue";
    export default {
        components: {
            TopNavbar
        },
        mounted() {
            if (!this.allow_user('sa')) { this.$router.push("/404"); }

            this.initMap();
            this.searchHandler();

            this.reqInterval = setInterval(() => {
                this.searchHandler();
            }, 10000);

        },
        beforeDestroy() {
            clearInterval(this.reqInterval);
        },
        data() {
            return {
                markers: [],
                infoWindows: [],
                map: null,
                driverList: [],
                reqInterval: null,
                center: { lat: 11.554712, lng: 104.872114 },
                search: {
                    text: "",
                    status: ""
                }
            }
        },
        methods: {
            initMap() {
                const element = document.getElementById('map')
                const options = {
                    zoom: 14,
                    center: new google.maps.LatLng(this.center.lat, this.center.lng)
                }
                this.map = new google.maps.Map(element, options);

                // var cityCircle = new google.maps.Circle({
                // 	strokeColor: '#0000FF',
                // 	strokeOpacity: 0.5,
                // 	strokeWeight: 1,
                // 	fillColor: '#0000FF',
                // 	fillOpacity: 0.15,
                // 	map: this.map,
                // 	center: {
                // 		lat: this.center.lat,
                // 		lng: this.center.lng
                // 	},
                // 	radius: 312000
                // });
            },
            setMarkers() {

                this.driverList = this.driverList.filter((array) => {
                    // console.log(this.config.getDistanceFromLatLonInKm(this.center.lat, this.center.lng, array.location_lat, array.location_lng));
                    return this.config.getDistanceFromLatLonInKm(this.center.lat, this.center.lng, array.location_lat, array.location_lng) < 30
                });

                for (let i = 0; i < this.driverList.length; i++) {

                    if (this.config.getDistanceFromLatLonInKm(this.center.lat, this.center.lng, this.driverList[i].location_lat, this.driverList[i].location_lng) < 312) {

                        let existed = false;
                        let index = null;
                        for (let j = 0; j < this.markers.length; j++) {
                            if (this.driverList[i].phone == this.markers[j]._id) {
                                existed = true;
                                index = j;
                            }
                        }
                        let position = new google.maps.LatLng(this.driverList[i].location_lat, this.driverList[i].location_lng);

                        if (!existed) {
                            let marker = new google.maps.Marker({
                                position: position,
                                map: this.map,
                                icon: {
                                    url: `https://cdn.oneme-express.com/assets/marker.png`,
                                    scaledSize: new google.maps.Size(38, 38),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(19, 19)
                                },
                                // label: {
                                //     text: `${this.driverList[i].name} - ${this.config.get_duration(this.driverList[i].location_last_update)}`, // label text
                                //     color: "red",
                                //     fontSize: "12px",
                                //     fontWeight: "bold",
                                // },
                                // title: this.driverList[i].name,
                            });
                            marker._id = this.driverList[i].phone;
                            marker.addListener("click", () => {
                                const url = `https://www.google.com/maps?q=${this.driverList[i].location_lat},${this.driverList[i].location_lng}(${this.driverList[i].name})`;
                                window.open(url, "_blank");
                            });

                            this.markers.push(marker);

                            this.infoWindows.push(new google.maps.InfoWindow({
                                content: `${this.driverList[i].name}<br>${this.config.get_duration(this.driverList[i].location_last_update)}`
                            }));

                            this.infoWindows[this.infoWindows.length - 1].open(map, this.markers[this.markers.length - 1]);
                        }

                        if (existed) {
                            this.markers[index].setPosition(position);
                            this.infoWindows[index].setContent(`<b>${this.driverList[i].name}</b><br><i>${this.config.get_duration(this.driverList[i].location_last_update)}</i>`);

                            // this.infoWindows[index].open(map, this.markers[index]);
                        }
                    }
                }

            },
            removeMarkers() {
                for (var i = 0; i < this.markers.length; i++) {
                    this.markers[i].setMap(null);
                }
                this.markers = [];
                this.infoWindows = [];
            },
            searchHandler(more = false) {
                this.$http.post(this.config.api + "/admin/driver/get_location_list", {
                    text: this.search.text,
                    status: this.search.status,
                    offset: more ? this.driverList.length : 0
                }).then(data => {
                    this.loaded = true;
                    this.search.text = "";
                    this.driverList = data.body.data;
                    // this.removeMarkers();
                    this.setMarkers();
                })
            },
        }
    }
</script>

<style>
    #map {
        position: relative;
        width: 100%;
        height: calc(100% - 70px);
    }

    .marker-label {
        position: absolute;
        background: rgba(66, 133, 244, 0.9);
        color: white;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
        transform: translate(-50%, -120%);
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/DriverMap.vue